import { useTranslation } from 'react-i18next';

import { Button, GenderToggle } from '@app/shared/ui/atoms/Common';
import { DateOfBirthInput } from '@app/shared/ui/molecules/Common';
import { ProfileFieldWithLabel } from '@app/shared/ui/molecules/EditProfile';
import { useUserDataForm } from '@app/shared/hooks/useUserDataForm';
import { telegramVibrate } from '@app/shared/utils/common';

export function Form() {
  const { t } = useTranslation();

  const {
    isUpdatingCurrentUserProfile,
    dateOfBirth,
    dateOfBirthErrorTranslationKey,
    handleDateOfBirthChange,
    handleDateOfBirthClear,
    gender,
    setGender,
    handleFormSubmit,
  } = useUserDataForm();

  return (
    <form className="relative mt-5 flex flex-col gap-5">
      <ProfileFieldWithLabel
        label={t('user_data_form.date_of_birth')}
        error={dateOfBirthErrorTranslationKey && t(dateOfBirthErrorTranslationKey)}
        hasErrorField
      >
        <DateOfBirthInput
          day={dateOfBirth.day}
          month={dateOfBirth.month}
          year={dateOfBirth.year}
          variant="white"
          align="center"
          onChange={handleDateOfBirthChange}
          onClear={handleDateOfBirthClear}
        />
      </ProfileFieldWithLabel>
      <ProfileFieldWithLabel label={t('user_data_form.gender')}>
        <GenderToggle
          value={gender}
          variant="white"
          onChange={(value) => {
            telegramVibrate();
            setGender(value);
          }}
        />
      </ProfileFieldWithLabel>
      <Button
        type="button"
        shadow="blue"
        onClick={handleFormSubmit}
        disabled={isUpdatingCurrentUserProfile}
      >
        {t('user_data_form.time_to_remember')}
      </Button>
    </form>
  );
}
